export enum ETierKey {
  Trial = 'Free Trial',
  Basic = 'Basic',
  Advanced = 'Advanced',
  AdvancedAnnual = 'Advanced-annual',
  Professional = 'Professional',
  ProfessionalAnnual = 'Professional-annual',
  Enterprise = 'Enterprise',
}

export interface ITier {
  name: string
  price: string
  price_annual: string
  price_id: string
  price_discount: string
  price_annual_discount: string
  price_discount_id: string
  title: string
  desc: string[]
}
export type ITiers = {
  [key: string]: ITier
}
export const tiers: ITiers = {
  [ETierKey.Trial]: {
    name: 'Free Trial',
    price: '$0 / 3 Days',
    price_id: '',
    price_annual: '',
    price_discount: '',
    price_annual_discount: '',
    price_discount_id: '',
    title: 'Features:',
    desc: [
      'Everything Included in Professional',
      '100 Parcel Queries',
      '10 Searches by Criteria',
      '2 Ranches',
      'Reports Require a Subscription',
    ],
  },
  [ETierKey.Basic]: {
    name: 'Basic',
    price: '$0 per seat / mo',
    price_annual: '',
    price_id: 'STRIPE_BASIC_PLAN_PRICE_ID',
    price_discount: '',
    price_annual_discount: '',
    price_discount_id: '',
    title: 'Features:',
    desc: [
      'Property Boundaries, Soil Properties',
      'Groundwater Banking, Statewide Crops',
      'Water Rights and California eWRIMS Points of Diversion',
      'Historic Climate Data, Hydrologic Regions, Flood Risk Maps',
      'Email Support, Regular Data Updates',
      'Access to our web, iPhone, and Android apps',
    ],
  },
  [ETierKey.Advanced]: {
    name: 'Advanced',
    price: '$10 per seat / mo',
    price_annual: '',
    price_id: 'STRIPE_ADVANCED_PLAN_PRICE_ID',
    price_discount: '$8 per seat / mo',
    price_annual_discount: '',
    price_discount_id: 'STRIPE_ADVANCED_PLAN_DISCOUNT_PRICE_ID',
    title: 'Key features include:',
    desc: [
      'Hydra Scores, Soil Scores',
      'GSA, District, and Subbasin Summaries',
      'APN’s, Owner Names, Mailing Addresses',
      '3 Ranches',
      '1 Report / mo',
    ],
  },
  [ETierKey.AdvancedAnnual]: {
    name: 'Advanced',
    price: '$8 per seat / mo',
    price_annual: '$96 per seat / yr',
    price_id: 'STRIPE_ADVANCED_ANNUAL_PLAN_PRICE_ID',
    price_discount: '$6.4 per seat / mo',
    price_annual_discount: '$77 per seat / yr',
    price_discount_id: 'STRIPE_ADVANCED_ANNUAL_PLAN_DISCOUNT_PRICE_ID',
    title: 'Key features include:',
    desc: [
      'Hydra Scores, Soil Scores',
      'GSA, District, and Subbasin Summaries',
      'APN’s, Owner Names, Mailing Addresses',
      '3 Ranches',
      '12 Reports / yr',
    ],
  },
  [ETierKey.Professional]: {
    name: 'Professional',
    price: '$100 per seat / mo',
    price_annual: '',
    price_id: 'STRIPE_PROFESSIONAL_PLAN_PRICE_ID',
    price_discount: '$80 per seat / mo',
    price_annual_discount: '',
    price_discount_id: 'STRIPE_PROFESSIONAL_PLAN_DISCOUNT_PRICE_ID',
    title: 'Every Advanced feature, plus:',
    desc: [
      'Advanced Property Search',
      'Bulk Ranch Import from  List or Shapefile',
      'Data Export',
      'Unlimited Ranches',
      'Unlimited Reports',
    ],
  },
  [ETierKey.ProfessionalAnnual]: {
    name: 'Professional',
    price: '$80 per seat / mo',
    price_annual: '$960 per seat / yr',
    price_id: 'STRIPE_PROFESSIONAL_ANNUAL_PLAN_PRICE_ID',
    price_discount: '$64 per seat / mo',
    price_annual_discount: '$768 per seat / yr',
    price_discount_id: 'STRIPE_PROFESSIONAL_ANNUAL_PLAN_DISCOUNT_PRICE_ID',
    title: 'Every Advanced feature, plus:',
    desc: [
      'Advanced Property Search',
      'Bulk Ranch Import from  List or Shapefile',
      'Data Export',
      'Unlimited Ranches',
      'Unlimited Reports',
    ],
  },
  [ETierKey.Enterprise]: {
    name: 'Enterprise',
    price: 'Custom',
    price_id: '',
    price_annual: '',
    price_discount: 'Custom',
    price_annual_discount: '',
    price_discount_id: '',
    title: 'Every Professional feature, plus:',
    desc: [
      'Custom Integrations',
      'Custom Data Retention',
      'Custom Property Details and Report Formats',
      'Team Management and Analytics',
      'Phone Support',
    ],
  },
}

export const statesArray = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
]
